﻿/* https://brandplatform.smartphoto.com/general/molecules/tooltip/ */
import { getParents } from "../../common/html";

export interface ICreateTooltipOptions {
	readonly buttonEl: HTMLElement;
	readonly containerEl: HTMLElement;
	readonly onOpen?: (containerEl: HTMLElement) => void;
	readonly onClose?: () => void;
	readonly openClass?: string;
	readonly tooltipSelector?: string;
	readonly toggleIconSelector?: string;
	readonly useCapture?: boolean;
}

export interface IToolTip {
	readonly dispose: () => void;
	readonly closeToolTip: () => void;
	readonly openToolTip: () => void;
}
export function initTooltip(options: ICreateTooltipOptions) {
	const {
		buttonEl,
		containerEl,
		onOpen,
		onClose,
		openClass,
		tooltipSelector,
		toggleIconSelector,
		useCapture = false,
	} = options;

	const closeToolTip = () => {
		containerEl.classList.remove(openClass || "m-tooltip--is-open");
		if (onClose) onClose();
		document.removeEventListener("click", onDocumentClick);
	};

	const openToolTip = () => {
		if (containerEl.classList.contains(openClass || "m-tooltip--is-open")) return;
		containerEl.classList.add(openClass || "m-tooltip--is-open");
		if (onOpen) onOpen(containerEl);
		document.addEventListener("click", onDocumentClick, { capture: useCapture });
	};

	const onButtonClick = (e: MouseEvent) => {
		if (getParents(e.target as HTMLElement, tooltipSelector || ".technical-price-tooltip").length < 1) {
			containerEl.classList.contains(openClass || "m-tooltip--is-open") ? closeToolTip() : openToolTip();
		}
	};

	const onDocumentClick = (e: MouseEvent) => {
		const selector =
			(tooltipSelector || ".technical-price-tooltip") + ", " + (toggleIconSelector || ".technical-price-info-icon");
		if (!(e.target as HTMLElement).closest(selector)) {
			closeToolTip();
		}
	};

	//open tooltip + function
	buttonEl?.addEventListener("click", onButtonClick);

	const dispose = () => {
		buttonEl?.removeEventListener("click", onButtonClick);
		document.removeEventListener("click", onDocumentClick);
	};

	return {
		dispose,
		closeToolTip,
		openToolTip,
	} as IToolTip;
}
